import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { ReactComponent as CheckedCircle } from '../../../../assets/icons/checked-circle.svg'

import useStyles from './styles'

const FormProgress = ({ items }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      {items.map((item, index) => (
        <div key={index} className={classes.item}>
          {item.isSuccess ? (
            <CheckedCircle />
          ) : (
            <div className={classnames(classes.number, { [classes.activeStyle]: item.isActive })}>{index + 1}</div>
          )}
          <div>{t(item.label)}</div>
        </div>
      ))}
    </div>
  )
}

FormProgress.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
      isSuccess: PropTypes.bool.isRequired
    })
  ).isRequired
}

export default FormProgress
